const optionRenderer = (choice) => {
  if (!choice) {
    return ''
  }
  return choice.caption ?? choice.genderDescription
}

export { optionRenderer }
